// /* eslint-disable no-use-before-define */
import React, { FC } from 'react';
import {
    MaterialUiCore,
    MaterialUiIcons,
    MaterialUiLab,
    MomentUtils,
    // @ts-ignore
} from '@gscope-mfe/common-libs';
import { List } from 'react-virtualized';

const { Autocomplete } = MaterialUiLab;
const { Chip, Tooltip, TextField, makeStyles } = MaterialUiCore;
const useStyles = makeStyles((theme, width) => ({
    root: {
        '& > * + *': {
            marginTop: theme.spacing(1),
        },
    },
}));
interface Props {
    id: any;
    width?: number;
    options: [string | any];
    setIndValue?: any;
    setValue: any;
    filter?: boolean;
    disabled?: boolean;
    more: any;
}

const getTags = (tagValue, getTagProps, leftSpace) => {
    const tags = [];
    let totalLength = 0;
    let count = 0;
    let neededLength = 5;
    for (const index in tagValue) {
        const option = tagValue[index];
        totalLength += option.length * 10 + 30 > 130 ? 130 : option.length * 10 + 30;
        if (totalLength > leftSpace) {
            neededLength = count;
        } else {
            count++;
        }
        if (parseInt(index) < neededLength) {
            tags.push({
                component: 'Chip',
                props: {
                    size: 'small',
                    label: option,
                    ...getTagProps({ index }),
                },
            });
        } else if (parseInt(index) == neededLength) {
            tags.push({
                component: 'Tooltip',
                props: {
                    id: 'dist-list-tooltip',
                    placement: 'bottom',
                },
            });
        } else {
            break;
        }
    }
    return tags;
};

const AutoCompleteField: FC<Props> = (props) => {
    // const trans = localizeLang();
    const [selectedNodes, setSelectedNodes] = React.useState<[string] | any>([]);
    const [open, setOpen] = React.useState<Boolean>(false);
    const classes = useStyles();
    const leftSpace: number = (props.width || 400) - 111;
    const width: number = props.width;
    const compMap = {
        Chip,
        Tooltip,
    };
    // let neededLength = 5;
    let dataOptions = [];
    // const tags = [];
    let count = 0;
    if (props.options) {
        if (props.filter) {
            dataOptions = props.options.map((opt) => {
                return opt.value;
            });
        } else {
            dataOptions = props.options;
        }
    }

    React.useEffect(() => {
        if (props.setIndValue?.length) {
            setSelectedNodes([...props.setIndValue]);
            props.setValue(props.setIndValue);
        } else {
            props.setValue([]);
            setSelectedNodes([]);
        }
    }, [props.setIndValue]);

    function handleChanges(ev, value) {
        setSelectedNodes(value);
        props.setValue(value);
    }

    const renderTags = (tagValue, getTagProps) =>
        getTags(tagValue, getTagProps, leftSpace).map((t, index) => {
            const ComponentType = t.component;
            const Component = compMap[ComponentType];
            if (ComponentType == 'Chip') {
                count++;
                return <Component key={index + Math.random()} style={{ maxWidth: 130, height: 22 }} {...t.props} />;
            } else {
                return (
                    <Component
                        key={index}
                        {...t.props}
                        style={{ maxWidth: 300 }}
                        title={
                            <div style={{ fontSize: '0.8rem' }}>
                                {selectedNodes.map((node, i) => (
                                    <div key={i}>{node}</div>
                                ))}
                            </div>
                        }
                    >
                        <a style={{ textDecoration: 'underline', color: '#0071dc' }}>
                            {' '}
                            +{tagValue.length - count} {props.more}
                        </a>
                    </Component>
                );
            }
        });

    const ListComponent = React.forwardRef((props: any, ref: any) => {
        const { children, ...other } = props;
        const itemCount = Array.isArray(children) ? children.length : 0;
        const itemSize = 36;
        const height =
            dataOptions.length * itemSize - selectedNodes.length * itemSize > 250
                ? 250
                : dataOptions.length * itemSize - selectedNodes.length * itemSize;
        return (
            <div ref={ref}>
                <div {...other}>
                    <List
                        height={height}
                        width={width || 400}
                        rowHeight={itemSize}
                        overscanCount={5}
                        rowCount={itemCount}
                        rowRenderer={(props) => {
                            return React.cloneElement(children[props.index], {
                                style: props.style,
                            });
                        }}
                    />
                </div>
            </div>
        );
    });

    return (
        <div className={classes.root}>
            <Autocomplete
                multiple
                id={props.id}
                size="small"
                style={{ width: props.width || 400 }}
                options={dataOptions}
                open={open}
                disabled={props.disabled}
                filterSelectedOptions
                defaultValue={[dataOptions[0]]}
                ListboxComponent={ListComponent}
                onChange={(event, value) => handleChanges(event, value)}
                onBlur={() => setOpen(false)}
                value={selectedNodes || []}
                renderTags={renderTags}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label={props.id}
                        onClick={() => {
                            if (!props.disabled) {
                                setOpen(!open);
                            }
                        }}
                        placeholder=""
                    />
                )}
            />
        </div>
    );
};

export { AutoCompleteField, getTags };
